import { render, staticRenderFns } from "./PolicyUsersView.vue?vue&type=template&id=44003eaa"
import script from "./PolicyUsersView.vue?vue&type=script&lang=js"
export * from "./PolicyUsersView.vue?vue&type=script&lang=js"
import style0 from "./PolicyUsersView.vue?vue&type=style&index=0&id=44003eaa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports